/** Separa ítems numerados pegados: "1. Uno. 2. Dos." → saltos dobles entre pasos. */
export function formatEnumeratedListBreaks(text: string): string {
  return String(text || '').replace(/([.!?])\s+(?=\d+\.\s)/g, '$1\n\n');
}
